<mat-chip-listbox [multiple]="true" class="main-chip-list">
  @if (tagIds.length === 0) {
    <div class="empty-placeholder">—</div>
  } @else {
    <div class="first-dummy">
      <mat-chip-option
        [selectable]="false"
        class="overflow-option"
        [dtHoverPopover]="popoverTemplate"
        [dtHoverPopoverContext]="{ tags: allTags }"
        [highlighted]="anyTagSelected()"
        dtHoverPopoverPosition="left"
        >&mldr;</mat-chip-option
      >
    </div>
    @for (tag of allTags; track trackByTagId(index, tag); let index = $index; let last = $last) {
      <div class="chip-wrapper" [attr.data-tag-id]="tag.id">
        <mat-chip-option [selected]="selectedTagIds.includes(tag.id)" (click)="$event.stopImmediatePropagation(); tagClick.emit(tag)">
          {{ tag.name | localizedString }}
        </mat-chip-option>
        @if (!last) {
          <mat-chip-option
            [selectable]="false"
            class="overflow-option"
            [dtHoverPopover]="popoverTemplate"
            [dtHoverPopoverContext]="{ tags: allTags.slice(index + 1) }"
            [highlighted]="anyTagSelected(index)"
            dtHoverPopoverPosition="left"
            >&mldr;</mat-chip-option
          >
        }
      </div>
    }
  }
</mat-chip-listbox>

<mat-chip-option [selectable]="false" class="distance-option">&mldr;</mat-chip-option>

<ng-template #popoverTemplate let-tags="tags">
  <mat-chip-listbox [multiple]="true" class="popover-chip-list">
    @for (tag of tags; track trackByTagId($index, tag)) {
      <mat-chip-option [selected]="selectedTagIds.includes(tag.id)" (click)="tagClick.emit(tag)">
        {{ tag.name | localizedString }}
      </mat-chip-option>
    }
  </mat-chip-listbox>
</ng-template>
